//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------

//  -- Constants ----------------------
import { ActionTypes } from 'store/constants';
import { map , filter } from "lodash"

//  ----------------------------------------------------------------------------
//  Reducers
//  ----------------------------------------------------------------------------

//  -- Example ------------------------
const examsInitial = [];
const teachersBingoInitial = [];
const learningModuleCountInitial = {};

export const oneway_bingo = (state = examsInitial, action) => {
    switch (action.type) {
        case ActionTypes.oneway_bingo.create_oneway_bingo:
            return [action.payload, ...state];
        case ActionTypes.oneway_bingo.list_oneway_bingo:
            return action.payload;
        case ActionTypes.oneway_bingo.update_oneway_bingo:
            return map(state,dt=>{
                if(dt.id===action.payload.id){
                    return action.payload;
                }
                return dt;
            })
        case ActionTypes.oneway_bingo.delete_oneway_bingo:
            return filter(state,dt=>dt.id!==action.payload)
        default:
            return state;
    }
};

export const teachers_bingo = (state = teachersBingoInitial, action) => {
    switch (action.type) {
        case ActionTypes.oneway_bingo.list_teachers_bingo:
            return action.payload;
        default:
            return state;
    }
};


export const learningModuleCount = (state = learningModuleCountInitial, action) => {
    switch (action.type) {
        case ActionTypes.oneway_bingo.get_learning_module_count:
            return action.payload;
        default:
            return state;
    }
};
